<div class="table-responsive">
     <app-frt-shipment-package-info-modal [frtPackageDetailsCalledFrom]="'frtBOL'"></app-frt-shipment-package-info-modal>
</div>